import React from "react";

import MatchCard from "./MatchCard";
import BracketConnectors from "./BracketConnectors";

import {
  CARD_W,
  ROUND_GAP,
  VIEW_PADDING_X,
  getBoardSize,
} from "./bracketLayout";

import { getId } from "./bracketUtils";

const RoundHeader = ({ round, x }) => (
  <div
    className="absolute top-6"
    style={{
      left: x,
      width: CARD_W,
    }}
  >
    <div className="flex items-start justify-between gap-3">
      <div>
        <h3 className="text-lg font-bold tracking-tight text-slate-900 dark:text-white">
          {round.title}
        </h3>

        <p className="mt-0.5 text-xs font-semibold uppercase tracking-[0.18em] text-slate-400 dark:text-slate-500">
          {round.subtitle}
        </p>
      </div>

      <div className="flex h-9 w-9 items-center justify-center rounded-2xl bg-slate-100 text-xs font-bold text-slate-600 ring-1 ring-slate-200 dark:bg-white/10 dark:text-slate-300 dark:ring-white/10">
        {round.matchCount}
      </div>
    </div>
  </div>
);

const BracketBoard = ({
  seed,
  rounds,
  onOpenCreate,
  onOpenEdit,
  onOpenScoreboard,
}) => {
  const { width, height } = getBoardSize(rounds, seed);

  return (
    <div className="relative overflow-auto bg-[radial-gradient(circle_at_top_left,rgba(59,130,246,0.08),transparent_32%),linear-gradient(180deg,#f8fafc,#eef2f7)] p-4 dark:bg-[radial-gradient(circle_at_top_left,rgba(59,130,246,0.12),transparent_32%),linear-gradient(180deg,#020617,#0f172a)]">
      <div
        className="relative z-0 rounded-[1.75rem] border border-white/80 bg-white/80 backdrop-blur dark:border-white/10 dark:bg-slate-950/70"
        style={{
          width,
          height,
          minWidth: width,
        }}
      >
        <BracketConnectors rounds={rounds} width={width} height={height} />

        {rounds.map((round) => {
          const x =
            VIEW_PADDING_X + round.roundIndex * (CARD_W + ROUND_GAP);

          return (
            <RoundHeader
              key={`header-${round.roundIndex}`}
              round={round}
              x={x}
            />
          );
        })}

        <div className="relative z-10">
          {rounds.map((round) =>
            round.pairs.map((pair) => (
              <MatchCard
                key={`${round.roundIndex}-${pair.matchIndex}-${
                  getId(pair.competiteur1) || "x"
                }-${getId(pair.competiteur2) || "y"}`}
                pair={pair}
                isFinal={round.roundIndex === rounds.length - 1}
                onOpenCreate={onOpenCreate}
                onOpenEdit={onOpenEdit}
                onOpenScoreboard={onOpenScoreboard}
              />
            )),
          )}
        </div>
      </div>
    </div>
  );
};

export default BracketBoard;